import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";


export class CardAlbumModel extends BaseObject {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(CardAlbumModel, v) : SKIP;
            },
            (v) => {
                return deserialize(CardAlbumModel, v);
            }
        );
    }

    constructor() {
        super();

        this._key = null;
        this._name = null;

        this._cards = [];
        this._rewardBunch = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get cards() {
        return this._cards;
    }

    set cards(value) {
        this._cards = value;
    }

    get rewardBunch() {
        return this._rewardBunch;
    }

    set rewardBunch(value) {
        this._rewardBunch = value;
    }

    valid() {

        if (!this.key || this.key.length <= 0) {
            return false;
        }

        if (!this.name || this.name.length <= 0) {
            return false;
        }

        if (!this.cards || this.cards.length <= 0) {
            return false;
        }

        if (this.cards && this.cards.some(v => !v || !RedactorUtils.getCard(v))) {
            return false;
        }

        if (this.rewardBunch && !this.rewardBunch.valid()) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.cards || this.cards.length <= 0;
    }

    copy() {
        let value = super.copy();
        value._id = "";
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new CardAlbumModel());
        } else if (target instanceof CardAlbumModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(CardAlbumModel, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _cards: alias("cards", list(Schema.primitive())),
    _rewardBunch: alias("reward_bunch", RewardBunch.schema())
});